import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { changeLang } from '@actions/common/actionCreators';
import { configs } from '@constants/configs/configs';

type AppDispatch = ThunkDispatch<{}, void, Action>;

export const exitImpersonation = async (dispatch: AppDispatch, switchBackLink: string): Promise<void> => {
    localStorage.removeItem('HHID');
    localStorage.removeItem('HHID2');
    localStorage.removeItem('activeTabIndex');
    sessionStorage.setItem('language', 'English');
    try {
        await dispatch(changeLang(configs.endpoints.CHANGE_LANGUAGE.processReplacements({ language: 'en' })));
    } catch (e) {
        console.warn('exitImpersonation: changeLang failed', e);
    } 
    sessionStorage.setItem('isInImpersonationMode', 'false');
    sessionStorage.setItem('impersonateHHID', '');
    sessionStorage.setItem('exitImpersonation', 'true');
    window.location.href = switchBackLink;
};
